<template>
  <div class="success-page">
    <!-- <header class="page-header">
      <button type="button" class="back-button" @click="$router.replace('/beecargo/satisfactionSurvey')">‹</button>
      <span>物流服务满意度调查</span>
    </header> -->
    <main class="success-content">
      <div class="watermark">
        <img src="@/assets/image/share/center-success-logo.png" alt="" />
      </div>
      <div class="success-bg">
        <svg xmlns="http://www.w3.org/2000/svg" width="255" height="196" viewBox="0 0 255 196" fill="none">
          <path d="M184.656 54C181.843 54 179.406 51.75 179.406 48.75C179.406 45.75 181.656 43.5 184.656 43.5C187.656 43.5 189.906 45.75 189.906 48.75C189.906 51.75 187.656 54 184.656 54ZM184.656 45.375C182.781 45.375 181.281 46.875 181.281 48.75C181.281 50.625 182.781 52.125 184.656 52.125C186.531 52.125 188.031 50.625 188.031 48.75C188.031 46.875 186.531 45.375 184.656 45.375ZM14.9681 47.625C10.8431 47.625 7.65562 44.25 7.65562 40.3125C7.65562 36.375 11.0306 33 14.9681 33C18.9056 33 22.2806 36.375 22.2806 40.3125C22.2806 44.25 19.0931 47.625 14.9681 47.625ZM14.9681 34.875C11.9681 34.875 9.53062 37.3125 9.53062 40.3125C9.53062 43.3125 11.9681 45.75 14.9681 45.75C17.9681 45.75 20.4056 43.3125 20.4056 40.3125C20.4056 37.3125 17.9681 34.875 14.9681 34.875Z" fill="white"/>
          <path d="M14.5931 114.562L16.8431 118.687L21.5306 119.437L18.1556 122.812L18.9056 127.5L14.5931 125.25L10.4681 127.5L11.2181 122.812L7.84312 119.437L12.5306 118.687L14.5931 114.562Z" fill="white"/>
          <path d="M244.093 81.75L247.093 87.9375L254.031 88.875L248.968 93.75L250.093 100.5L244.093 97.3125L237.906 100.5L239.218 93.75L234.156 88.875L241.093 87.9375L244.093 81.75Z" fill="white"/>
          <path d="M9.53062 91.125V80.8125L19.6556 91.125H9.53062Z" fill="white"/>
          <path d="M218.031 157.688V145.125L230.406 157.688H218.031Z" fill="white"/>
          <path d="M14.3625 14.67L15.8156 13.485L26.7225 26.8481L25.2694 28.0331L14.3625 14.67ZM0 2.37937L1.45125 1.1925L12.3581 14.5556L10.9069 15.7425L0 2.37937Z" fill="white"/>
          <path d="M11.115 13.9556L15.3956 13.4306L15.6244 15.2906L11.3438 15.8156L11.115 13.9556ZM234.42 118.097L253.511 113.284L253.969 115.103L234.878 119.914L234.42 118.097ZM214.717 126.739L233.809 121.927L234.266 123.746L215.177 128.557L214.717 126.739Z" fill="white"/>
          <path d="M232.644 122.955L234.158 118.322L235.939 118.903L234.426 123.538L232.644 122.955Z" fill="white"/>
          <path d="M69.3431 6.9375H68.4056C68.0306 6.9375 67.6556 6.5625 67.6556 6.1875V0.750001C67.6556 0.375001 68.0306 0 68.4056 0H69.3431C69.7181 0 70.0931 0.375001 70.0931 0.750001V6.1875C70.0931 6.5625 69.7181 6.9375 69.3431 6.9375ZM69.3431 23.0625H68.4056C68.0306 23.0625 67.6556 22.6875 67.6556 22.3125V16.875C67.6556 16.5 68.0306 16.125 68.4056 16.125H69.3431C69.7181 16.125 70.0931 16.5 70.0931 16.875V22.3125C70.0931 22.6875 69.7181 23.0625 69.3431 23.0625ZM80.9681 11.4375V12.375C80.9681 12.75 80.5931 13.125 80.2181 13.125H74.7806C74.4056 13.125 74.0306 12.75 74.0306 12.375V11.4375C74.0306 11.0625 74.4056 10.6875 74.7806 10.6875H80.2181C80.5931 10.6875 80.9681 11.0625 80.9681 11.4375ZM63.9056 11.4375V12.375C63.9056 12.75 63.5306 13.125 63.1556 13.125H57.7181C57.3431 13.125 56.9681 12.75 56.9681 12.375V11.4375C56.9681 11.0625 57.3431 10.6875 57.7181 10.6875H63.1556C63.7181 10.6875 63.9056 11.0625 63.9056 11.4375Z" fill="white"/>
          <path d="M210.343 64.3125H209.781C209.406 64.3125 209.031 63.9375 209.031 63.5625V59.4375C209.031 59.0625 209.406 58.6875 209.781 58.6875H210.343C210.718 58.6875 211.093 59.0625 211.093 59.4375V63.5625C211.093 63.9375 210.718 64.3125 210.343 64.3125ZM210.343 77.4375H209.781C209.406 77.4375 209.031 77.0625 209.031 76.6875V72.5625C209.031 72.1875 209.406 71.8125 209.781 71.8125H210.343C210.718 71.8125 211.093 72.1875 211.093 72.5625V76.6875C211.093 77.25 210.718 77.4375 210.343 77.4375ZM220.093 68.0625V68.625C220.093 69 219.718 69.375 219.343 69.375H215.218C214.843 69.375 214.468 69 214.468 68.625V68.0625C214.468 67.6875 214.843 67.3125 215.218 67.3125H219.343C219.718 67.3125 220.093 67.6875 220.093 68.0625ZM206.031 68.0625V68.625C206.031 69 205.656 69.375 205.281 69.375H201.156C200.781 69.375 200.406 69 200.406 68.625V68.0625C200.406 67.6875 200.781 67.3125 201.156 67.3125H205.281C205.843 67.3125 206.031 67.6875 206.031 68.0625Z" fill="white"/>
          <path d="M199.218 179.75H220.593V181.625H199.218V179.75Z" fill="white"/>
          <path d="M199.218 186.875H220.593V188.75H199.218V186.875Z" fill="white"/>
          <path d="M199.218 193.25H220.593V195.125H199.218V193.25Z" fill="white"/>
          <path d="M42.5606 19.9912L43.7137 18.5137L58.1981 29.82L57.045 31.2975L42.5606 19.9912Z" fill="white"/>
          <path d="M38.0512 25.6931L39.2044 24.2156L53.6906 35.5219L52.5356 36.9994L38.0512 25.6931Z" fill="white"/>
          <path d="M34.1888 30.7631L35.3419 29.2837L49.8281 40.59L48.6731 42.0694L34.1888 30.7631Z" fill="white"/>
        </svg>
      </div>
      <div class="success-icon">✓</div>
      <h1>感谢您的评价！</h1>
      <p>
        您提交的客户满意度调查已完成，我们已收到您的反馈。您的意见将作为我司持续优化服务质量的重要依据。
      </p>
    </main>
  </div>
</template>

<script>
export default {
  name: "SatisfactionSurveySuccess",
};
</script>

<style lang="scss" scoped>
.success-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #ff733c, #ffb246);
  color: #fff;
}
.page-header {
  height: 44px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #3d3833;
  font-size: 17px;
}
.back-button {
  position: absolute;
  left: 12px;
  border: 0;
  padding: 0 6px 4px;
  background: transparent;
  color: #3d3833;
  font-size: 32px;
}
.success-content {
  position: relative;
  padding: 168px 28px 0;
  overflow: hidden;
}
.watermark {
  position: absolute;
  top: 58px;
  left: 50%;
  font-weight: bold;
  white-space: nowrap;
  transform: translateX(-50%);
  width: 319px;
  height: 319px;
  opacity: .2;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
.success-bg {
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
}
.success-icon {
  position: relative;
  z-index: 1;
  width: 116px;
  height: 116px;
  margin: 0 auto 94px;
  border-radius: 50%;
  background: #27df69;
  color: #f7a15d;
  font-size: 82px;
  font-weight: bold;
  line-height: 106px;
  text-align: center;
}
h1 {
  position: relative;
  z-index: 1;
  margin: 0 0 24px;
  font-size: 20px;
  text-align: center;
}
p {
  position: relative;
  z-index: 1;
  margin: 0;
  font-size: 16px;
  line-height: 24px;
}

@media (min-width: 768px) {
  .success-content {
    box-sizing: border-box;
    width: 720px;
    min-height: 100vh;
    margin: 0 auto;
    padding: 168px 96px 48px;
  }
  .success-icon {
    margin-bottom: 72px;
  }
  h1 {
    font-size: 24px;
  }
  p {
    text-align: center;
  }
}
</style>
